var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDrupal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#379ECC;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.8,17.2c5.2,5.6,8.3,11.8,5,20C43.3,43.1,37.9,48,31.4,50c3.5-2.5,5.8-6.5,5.8-11.2c0-3.6-1.4-7-3.8-9.4 c4.3-1.2,7.5-5.2,7.5-10C41,18.7,40.9,17.9,40.8,17.2z M22.5,0c2.7,3.3,6.1,6.2,9.5,9.2c-0.5-0.1-0.9-0.1-1.4-0.1 c-5.7,0-10.4,4.7-10.4,10.4c0,2.2,0.7,4.2,1.8,5.9c-6.7,0.8-12,6.5-12,13.5c0,3.3,1.2,6.4,3.2,8.8C3.9,41.9,0.7,31,4.3,22.2 C9.6,9.1,23.9,14.3,22.5,0z M23.7,31c4.4,0,7.9,3.5,7.9,7.9c0,4.4-3.5,7.9-7.9,7.9c-4.4,0-7.9-3.5-7.9-7.9 C15.8,34.5,19.3,31,23.7,31z M30.6,13.4c3.3,0,6,2.7,6,6c0,3.3-2.7,6-6,6c-3.3,0-6-2.7-6-6C24.6,16.1,27.3,13.4,30.6,13.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrupal);
export default __webpack_public_path__ + "static/media/drupal.b263a2371f0835e318b201532a9bd29f.svg";
export { ForwardRef as ReactComponent };